import { BiLayoutItem, kBiGridColumns } from '@euler/model/bi/dashboard';
import { kBiGridGapPx, kBiGridRowPx } from './biGridLayout';

export interface BiRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/** One grid column at a content width, the gap after it included. */
export function biColumnPx(width: number): number {
  return (width + kBiGridGapPx) / kBiGridColumns;
}

/** Where an item of the 12-column grid is drawn at a content width. */
export function biItemRect(
  item: Pick<BiLayoutItem, 'x' | 'y' | 'w' | 'h'>,
  width: number,
): BiRect {
  const column = biColumnPx(width);
  return {
    left: item.x * column,
    top: item.y * kBiGridRowPx,
    width: item.w * column - kBiGridGapPx,
    height: item.h * kBiGridRowPx - kBiGridGapPx,
  };
}

/** The grid's drawn height for items ending at row `bottom`. */
export function biGridHeight(bottom: number): number {
  return Math.max(0, bottom * kBiGridRowPx - kBiGridGapPx);
}

/** The cell a pixel offset snaps to: the nearest column and row. */
export function biSnapCells(
  dx: number,
  dy: number,
  width: number,
): { columns: number; rows: number } {
  return {
    columns: Math.round(dx / biColumnPx(width)),
    rows: Math.round(dy / kBiGridRowPx),
  };
}
